import './sidebar-layout.css';

import UserInactiveInfo from 'app-sections/common/users/user-inactive-info/UserInactiveInfo';
import UpdatesListenerWrapper from 'app-sections/common/websockets/updates-listener-wrapper/UpdatesListenerWrapper';
import SwoLiftedListener from 'app-sections/user/common/swo-lifted-listener/SwoLiftedListener';
import { Outlet } from 'react-router-dom';
import AppMessageOverlay from 'ui/components/app-message-overlay/AppMessageOverlay';
import ScrollController from 'ui/components/scroll-controller/ScrollController';

import LayoutErrorBoundary from '../../../errors/LayoutErrorBoundary';
import AppSidebar from '../app-sidebar/AppSidebar';
import AppToolbar from '../app-toolbar/AppToolbar';
import { isEnv } from 'ui/helpers/environments';

export default function SidebarLayout() {
  return (
    <div className="root">
      <UserInactiveInfo />
      <AppSidebar />
      <div className="layout-wrapper">
        <AppToolbar />
        <main className="content" id="main-scroll-container">
          <LayoutErrorBoundary>
            <ScrollController />
            <UpdatesListenerWrapper />
            <SwoLiftedListener />
            <Outlet />
            {/* <CustomRoutesProvider mobileAnimationType="opacity" /> */}
          </LayoutErrorBoundary>
        </main>
      </div>
      {!isEnv('production') && <AppMessageOverlay />}
    </div>
  );
}
